import { useState } from "react";
import React from "react";
import { ComposedModal, Button, Tabs, Tab, ModalBody, ModalHeader, Grid, Row, Column } from "carbon-components-react";
import { useEffect } from "react";

function MedicalPlanDetails({planId}) {
  const [open, setOpen] = useState(false);
  const [ umrPlan, setUmrPlan] = useState(false);
  const [ mercyPlan, setMercyPlan] = useState(false);
  const [ waivedPlan, setWaivedPlan] = useState(false);

  useEffect(() => {
    if(planId === "MED"){
      setUmrPlan(true);
      setMercyPlan(false);
      setWaivedPlan(false);
    } else if (planId === "MERCY") {
      setMercyPlan(true);
      setUmrPlan(false);
      setWaivedPlan(false);
    } else if (planId === "WAIVED"){
      setWaivedPlan(true);
      setMercyPlan(false);
      setUmrPlan(false);
    }

  },[planId])

  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-4 -ml-6">
          <p className="text-2xl">Medical Plan Details</p>
        </ModalHeader>
        <ModalBody className="-ml-8" aria-label="Plan Details">
            {umrPlan && 
              <Tabs className="mt-2" label="Medical Plan Details">
                <Tab label="UMR PPO Plan">
                <div className="mb-8">
                  <Grid>
                    <Row className="text-left bg-gray-400">
                      <Column className="mt-2 mb-2"></Column>
                      <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                      <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                      <Column className="mt-2 mb-2">
                        $750 Individual
                        <br />
                        $1,500 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $4,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Coinsurance</Column>
                      <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                      <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $5,000 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $4,000 Individual
                        <br />
                        $10,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                      <Column className="mt-2 mb-2">100%</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Physician Visits</Column>
                      <Column className="mt-2 mb-2">
                        $25 Copay - Primary Care
                        <br />
                        $40 Copay - Specialty Care
                      </Column>
                      <Column className="mt-2 mb-2">
                        60% After Deductible
                        <br />
                        60% After Deductible
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Emergency Room Care</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Urgent Care Services</Column>
                      <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Inpatient Services</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Chiropractic Services</Column>
                      <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                      <Column className="mt-2 mb-2">Not Covered</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                  </Grid>
                </div>
                <div>
                  <Grid className="mb-8">
                    <Row className="bg-gray-400">
                      <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $5 Copay - Tier 1<br />
                        $45 Copay - Tier 2<br />
                        $85 Copay - Tier 3
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $10 Copay - Tier 1<br />
                        $90 Copay - Tier 2<br />
                        $170 Copay - Tier 3
                      </Column>
                    </Row>
                  </Grid>
                </div>
                <div className="ml-2 sm:ml-6 ">
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                    <p>
                      UMR Home Page: www.umr.com
                      <br />
                      Express Scripts: www.express-scripts.com
                      <br />
                    </p>
                    Medical Customer Service: 800-826-9781
                  </div>
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Important Information</div>
                    <p>
                      • Dependent children may be covered up to age 26.
                      <br />
                      • Your domestic partner and their children may be eligible for this plan.
                      <br />
                      Please see Employee Relations for more details.
                    </p>
                  </div>
                </div>
                </Tab>
                <Tab label="Mercy PPO Plan">
              <div className="mb-8">
                <Grid>
                  <Row className="text-left bg-gray-400">
                    <Column className="mt-2 mb-2"></Column>
                    <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                    <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                    <Column className="mt-2 mb-2">
                      $500 Individual
                      <br />
                      $1,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $4,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Coinsurance</Column>
                    <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                    <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $5,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $4,000 Individual
                      <br />
                      $10,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                    <Column className="mt-2 mb-2">100%</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Physician Visits</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Primary Care
                      <br />
                      $20 Copay - Specialty Care
                    </Column>
                    <Column className="mt-2 mb-2">
                      60% After Deductible
                      <br />
                      60% After Deductible
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Emergency Room Care</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Urgent Care Services</Column>
                    <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Inpatient Services</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Chiropractic Services</Column>
                    <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                    <Column className="mt-2 mb-2">Not Covered</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Tier 1<br />
                      $45 Copay - Tier 2<br />
                      $85 Copay - Tier 3
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $10 Copay - Tier 1<br />
                      $90 Copay - Tier 2<br />
                      $170 Copay - Tier 3
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Nurse on Call - 24 Hours a Day / 7 Days a Week</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">
                      
                        When you have an illness or injury and your Mercy primary care doctor isn’t available, our experienced nurses will help you decide whether to:
                        <br />
                        • Treat the condition on your own at home.
                        <br />
                        • Wait and see your physician in the office.
                        <br />
                        • Go to an urgent care or emergency department.
                        <br />
                        With one call, you’ll get the advice and peace of mind you need – and in some cases, save time and money.
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div className="ml-2 sm:ml-6">
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                  <p>
                    Mercy Home Page: www.mercyoptions.net
                    <br />
                    Express Scripts: www.express-scripts.com
                    <br />
                    Medical Customer Service: 1-877-875-7700
                  </p>
                </div>
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Important Information</div>
                  <p>
                    • Dependent children may be covered up to age 26.
                    <br />
                    • Your domestic partner and their children may be eligible for this plan.
                    <br />
                    Please see Employee Relations for more details.
                  </p>
                </div>
              </div>
                </Tab>
                <Tab label="Call a Doctor Plus">
              <div >
                <h3 className="mb-2">Call a Doctor Plus</h3>
                <span className="font-bold">Call a Doctor is not voluntary and all employees are auto-enrolled at no cost to the employee, even if medical coverage is waived</span>
                <div className="mb-8 py-2 px-4 -ml-2 sm:ml-0 sm:px-4 bg-gray-200">
                  <p>
                    • Provides unlimited access to doctors, counselors, patient advisors and a wellness platform
                    <br />
                    • Call a Doctor Plus is the new age of healthcare - Healthcare, when you need it, wherever you are!
                    <br />
                    • Provides a complete package of virtual benefits, which give you access to doctors, counselors and support from patient healthcare advisors
                    <br />• Provides a perfect benefit for individuals that work part-time, people that travel extensively, fully insured people with high deductible plans, and uninsured individuals - all by giving each group the same unlimited access to physicians, counselors and patient advisors, as well as a wellness platform - for the entire household
                  </p>
                </div>
                <div className="-ml-2 sm:ml-0">
                  <Grid className="mb-8 bg-gray-200">
                    <Row className="py-2">
                      <Column>
                        <span className="font-bold">Doctors:</span> Doctors are available for you 24 hours a day to ask questions, receive consultation and even receive prescriptions for medications{" "}
                      </Column>
                      <Column>
                        <span className="font-bold">Counselors:</span> Our counselors are available for you 24 hours a day to seek advice or discuss areas such as depression, dependency, stress and more
                      </Column>
                    </Row>
                    <Row>
                      <Column>
                        <span className="font-bold">Patient Advisors:</span> Our patient advisors can help you with questions you have about appropriate healthcare, medical bills, insurance denials, etc.
                      </Column>

                      <Column>
                        <span className="font-bold">Wellness:</span> Access wellness tools, health assessments, diet and workout plans. As well as hundreds of articles and resources to maintain your healthy lifestyle.
                      </Column>
                    </Row>
                    <Row className="py-2">
                      <Column>
                        <span className="text-red-600 font-bold">WEBSITE</span> www.cardplus.com
                      </Column>
                      <Column>
                        <span className="text-red-600 font-bold">TELEPHONE</span> 800.362.2667
                      </Column>
                    </Row>
                  </Grid>
                </div>
              </div>
                </Tab>
              </Tabs>
            }
            {mercyPlan && 
              <Tabs className="mt-2" label="Medical Plan Details">
                <Tab label="Mercy PPO Plan">
              <div className="mb-8">
                <Grid>
                  <Row className="text-left bg-gray-400">
                    <Column className="mt-2 mb-2"></Column>
                    <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                    <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                    <Column className="mt-2 mb-2">
                      $500 Individual
                      <br />
                      $1,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $4,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Coinsurance</Column>
                    <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                    <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $5,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $4,000 Individual
                      <br />
                      $10,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                    <Column className="mt-2 mb-2">100%</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Physician Visits</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Primary Care
                      <br />
                      $20 Copay - Specialty Care
                    </Column>
                    <Column className="mt-2 mb-2">
                      60% After Deductible
                      <br />
                      60% After Deductible
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Emergency Room Care</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Urgent Care Services</Column>
                    <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Inpatient Services</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Chiropractic Services</Column>
                    <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                    <Column className="mt-2 mb-2">Not Covered</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Tier 1<br />
                      $45 Copay - Tier 2<br />
                      $85 Copay - Tier 3
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $10 Copay - Tier 1<br />
                      $90 Copay - Tier 2<br />
                      $170 Copay - Tier 3
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Nurse on Call - 24 Hours a Day / 7 Days a Week</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">
                      
                        When you have an illness or injury and your Mercy primary care doctor isn’t available, our experienced nurses will help you decide whether to:
                        <br />
                        • Treat the condition on your own at home.
                        <br />
                        • Wait and see your physician in the office.
                        <br />
                        • Go to an urgent care or emergency department.
                        <br />
                        With one call, you’ll get the advice and peace of mind you need – and in some cases, save time and money.
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div className="ml-2 sm:ml-6">
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                  <p>
                    Mercy Home Page: www.mercyoptions.net
                    <br />
                    Express Scripts: www.express-scripts.com
                    <br />
                    Medical Customer Service: 1-877-875-7700
                  </p>
                </div>
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Important Information</div>
                  <p>
                    • Dependent children may be covered up to age 26.
                    <br />
                    • Your domestic partner and their children may be eligible for this plan.
                    <br />
                    Please see Employee Relations for more details.
                  </p>
                </div>
              </div>
                </Tab>
                <Tab label="UMR PPO Plan">
                <div className="mb-8">
                  <Grid>
                    <Row className="text-left bg-gray-400">
                      <Column className="mt-2 mb-2"></Column>
                      <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                      <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                      <Column className="mt-2 mb-2">
                        $750 Individual
                        <br />
                        $1,500 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $4,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Coinsurance</Column>
                      <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                      <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $5,000 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $4,000 Individual
                        <br />
                        $10,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                      <Column className="mt-2 mb-2">100%</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Physician Visits</Column>
                      <Column className="mt-2 mb-2">
                        $25 Copay - Primary Care
                        <br />
                        $40 Copay - Specialty Care
                      </Column>
                      <Column className="mt-2 mb-2">
                        60% After Deductible
                        <br />
                        60% After Deductible
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Emergency Room Care</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Urgent Care Services</Column>
                      <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Inpatient Services</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Chiropractic Services</Column>
                      <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                      <Column className="mt-2 mb-2">Not Covered</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                  </Grid>
                </div>
                <div>
                  <Grid className="mb-8">
                    <Row className="bg-gray-400">
                      <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $5 Copay - Tier 1<br />
                        $45 Copay - Tier 2<br />
                        $85 Copay - Tier 3
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $10 Copay - Tier 1<br />
                        $90 Copay - Tier 2<br />
                        $170 Copay - Tier 3
                      </Column>
                    </Row>
                  </Grid>
                </div>
                <div className="ml-2 sm:ml-6 ">
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                    <p>
                      UMR Home Page: www.umr.com
                      <br />
                      Express Scripts: www.express-scripts.com
                      <br />
                    </p>
                    Medical Customer Service: 800-826-9781
                  </div>
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Important Information</div>
                    <p>
                      • Dependent children may be covered up to age 26.
                      <br />
                      • Your domestic partner and their children may be eligible for this plan.
                      <br />
                      Please see Employee Relations for more details.
                    </p>
                  </div>
                </div>
                </Tab>
                <Tab label="Call a Doctor Plus">
              <div >
                <h3 className="mb-4">Call a Doctor Plus</h3>
                <div className="mb-8 py-2 px-4 -ml-2 sm:ml-0 sm:px-4 bg-gray-200">
                  <p>
                    • Provides unlimited access to doctors, counselors, patient advisors and a wellness platform
                    <br />
                    • Call a Doctor Plus is the new age of healthcare - Healthcare, when you need it, wherever you are!
                    <br />
                    • Provides a complete package of virtual benefits, which give you access to doctors, counselors and support from patient healthcare advisors
                    <br />• Provides a perfect benefit for individuals that work part-time, people that travel extensively, fully insured people with high deductible plans, and uninsured individuals - all by giving each group the same unlimited access to physicians, counselors and patient advisors, as well as a wellness platform - for the entire household
                  </p>
                </div>
                <div className="-ml-2 sm:ml-0">
                  <Grid className="mb-8 bg-gray-200">
                    <Row className="py-2">
                      <Column>
                        <span className="font-bold">Doctors:</span> Doctors are available for you 24 hours a day to ask questions, receive consultation and even receive prescriptions for medications{" "}
                      </Column>
                      <Column>
                        <span className="font-bold">Counselors:</span> Our counselors are available for you 24 hours a day to seek advice or discuss areas such as depression, dependency, stress and more
                      </Column>
                    </Row>
                    <Row>
                      <Column>
                        <span className="font-bold">Patient Advisors:</span> Our patient advisors can help you with questions you have about appropriate healthcare, medical bills, insurance denials, etc.
                      </Column>

                      <Column>
                        <span className="font-bold">Wellness:</span> Access wellness tools, health assessments, diet and workout plans. As well as hundreds of articles and resources to maintain your healthy lifestyle.
                      </Column>
                    </Row>
                    <Row className="py-2">
                      <Column>
                        <span className="text-red-600 font-bold">WEBSITE</span> www.cardplus.com
                      </Column>
                      <Column>
                        <span className="text-red-600 font-bold">TELEPHONE</span> 800.362.2667
                      </Column>
                    </Row>
                  </Grid>
                </div>
              </div>
                </Tab>
              </Tabs>
            }
            {waivedPlan && 
              <Tabs className="mt-2" label="Medical Plan Details">
                <Tab label="UMR PPO Plan">
                <div className="mb-8">
                  <Grid>
                    <Row className="text-left bg-gray-400">
                      <Column className="mt-2 mb-2"></Column>
                      <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                      <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                      <Column className="mt-2 mb-2">
                        $750 Individual
                        <br />
                        $1,500 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $4,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Coinsurance</Column>
                      <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                      <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                      <Column className="mt-2 mb-2">
                        $2,000 Individual
                        <br />
                        $5,000 Family
                      </Column>
                      <Column className="mt-2 mb-2">
                        $4,000 Individual
                        <br />
                        $10,000 Family
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                      <Column className="mt-2 mb-2">100%</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Physician Visits</Column>
                      <Column className="mt-2 mb-2">
                        $25 Copay - Primary Care
                        <br />
                        $40 Copay - Specialty Care
                      </Column>
                      <Column className="mt-2 mb-2">
                        60% After Deductible
                        <br />
                        60% After Deductible
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Emergency Room Care</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                      <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Urgent Care Services</Column>
                      <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Inpatient Services</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Chiropractic Services</Column>
                      <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                      <Column className="mt-2 mb-2">Not Covered</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                      <Column className="mt-2 mb-2">90% After Deductible</Column>
                      <Column className="mt-2 mb-2">60% After Deductible</Column>
                    </Row>
                  </Grid>
                </div>
                <div>
                  <Grid className="mb-8">
                    <Row className="bg-gray-400">
                      <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                    </Row>
                    <Row>
                      <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $5 Copay - Tier 1<br />
                        $45 Copay - Tier 2<br />
                        $85 Copay - Tier 3
                      </Column>
                    </Row>
                    <Row className="bg-gray-200">
                      <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                      <Column className="mt-2 mb-2">
                        $10 Copay - Tier 1<br />
                        $90 Copay - Tier 2<br />
                        $170 Copay - Tier 3
                      </Column>
                    </Row>
                  </Grid>
                </div>
                <div className="ml-2 sm:ml-6 ">
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                    <p>
                      UMR Home Page: www.umr.com
                      <br />
                      Express Scripts: www.express-scripts.com
                      <br />
                    </p>
                    Medical Customer Service: 800-826-9781
                  </div>
                  <div className="mb-8 ">
                    <div className="mb-1 font-bold text-red-600">Important Information</div>
                    <p>
                      • Dependent children may be covered up to age 26.
                      <br />
                      • Your domestic partner and their children may be eligible for this plan.
                      <br />
                      Please see Employee Relations for more details.
                    </p>
                  </div>
                </div>
                </Tab>
                <Tab label="Mercy PPO Plan">
              <div className="mb-8">
                <Grid>
                  <Row className="text-left bg-gray-400">
                    <Column className="mt-2 mb-2"></Column>
                    <Column className="mt-2 mb-2 font-bold">In-Network</Column>
                    <Column className="mb-2 mt-2 font-bold">Out-of-Network</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Calendar Year Deductible</Column>
                    <Column className="mt-2 mb-2">
                      $500 Individual
                      <br />
                      $1,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $4,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Coinsurance</Column>
                    <Column className="mt-2 mb-2">Plan Pays 90% After Deductible</Column>
                    <Column className="mt-2 mb-2">Plan Pays 60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Out-of-Pocket Maximum (Does not include deductible)</Column>
                    <Column className="mt-2 mb-2">
                      $2,000 Individual
                      <br />
                      $5,000 Family
                    </Column>
                    <Column className="mt-2 mb-2">
                      $4,000 Individual
                      <br />
                      $10,000 Family
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Preventive Services / Well Care</Column>
                    <Column className="mt-2 mb-2">100%</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Physician Visits</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Primary Care
                      <br />
                      $20 Copay - Specialty Care
                    </Column>
                    <Column className="mt-2 mb-2">
                      60% After Deductible
                      <br />
                      60% After Deductible
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Emergency Room Care</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                    <Column className="mt-2 mb-2">100% after $150 Copay</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Urgent Care Services</Column>
                    <Column className="mt-2 mb-2">100% after $50 Copay</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Inpatient Services</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Outpatient Surgery</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Chiropractic Services</Column>
                    <Column className="mt-2 mb-2">50% Deductible Waived</Column>
                    <Column className="mt-2 mb-2">Not Covered</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Infertility Treatment (subject to lifetime max $15,000)</Column>
                    <Column className="mt-2 mb-2">90% After Deductible</Column>
                    <Column className="mt-2 mb-2">60% After Deductible</Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Prescription Drug Card - Express Scripts</Column>
                  </Row>
                  <Row>
                    <Column className="mt-2 mb-2">Retail (up to a 30 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $5 Copay - Tier 1<br />
                      $45 Copay - Tier 2<br />
                      $85 Copay - Tier 3
                    </Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">Mail Order (up to a 90 day supply)</Column>
                    <Column className="mt-2 mb-2">
                      $10 Copay - Tier 1<br />
                      $90 Copay - Tier 2<br />
                      $170 Copay - Tier 3
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div>
                <Grid className="mb-8">
                  <Row className="bg-gray-400">
                    <Column className="mt-2 mb-2 font-bold">Nurse on Call - 24 Hours a Day / 7 Days a Week</Column>
                  </Row>
                  <Row className="bg-gray-200">
                    <Column className="mt-2 mb-2">
                      
                        When you have an illness or injury and your Mercy primary care doctor isn’t available, our experienced nurses will help you decide whether to:
                        <br />
                        • Treat the condition on your own at home.
                        <br />
                        • Wait and see your physician in the office.
                        <br />
                        • Go to an urgent care or emergency department.
                        <br />
                        With one call, you’ll get the advice and peace of mind you need – and in some cases, save time and money.
                    </Column>
                  </Row>
                </Grid>
              </div>
              <div className="ml-2 sm:ml-6">
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Website and Customer Service Information</div>
                  <p>
                    Mercy Home Page: www.mercyoptions.net
                    <br />
                    Express Scripts: www.express-scripts.com
                    <br />
                    Medical Customer Service: 1-877-875-7700
                  </p>
                </div>
                <div className="mb-8">
                  <div className="mb-1 font-bold text-red-600">Important Information</div>
                  <p>
                    • Dependent children may be covered up to age 26.
                    <br />
                    • Your domestic partner and their children may be eligible for this plan.
                    <br />
                    Please see Employee Relations for more details.
                  </p>
                </div>
              </div>
                </Tab>
                <Tab label="Call a Doctor Plus">
              <div >
                <h3 className="mb-2">Call a Doctor Plus</h3>
                <span className="font-bold">Call a Doctor is not voluntary and all employees are auto-enrolled at no cost to the employee, even if medical coverage is waived</span>
                <div className="mb-8 py-2 px-4 -ml-2 sm:ml-0 sm:px-4 bg-gray-200">
                  <p>
                    • Provides unlimited access to doctors, counselors, patient advisors and a wellness platform
                    <br />
                    • Call a Doctor Plus is the new age of healthcare - Healthcare, when you need it, wherever you are!
                    <br />
                    • Provides a complete package of virtual benefits, which give you access to doctors, counselors and support from patient healthcare advisors
                    <br />• Provides a perfect benefit for individuals that work part-time, people that travel extensively, fully insured people with high deductible plans, and uninsured individuals - all by giving each group the same unlimited access to physicians, counselors and patient advisors, as well as a wellness platform - for the entire household
                  </p>
                </div>
                <div className="-ml-2 sm:ml-0">
                  <Grid className="mb-8 bg-gray-200">
                    <Row className="py-2">
                      <Column>
                        <span className="font-bold">Doctors:</span> Doctors are available for you 24 hours a day to ask questions, receive consultation and even receive prescriptions for medications{" "}
                      </Column>
                      <Column>
                        <span className="font-bold">Counselors:</span> Our counselors are available for you 24 hours a day to seek advice or discuss areas such as depression, dependency, stress and more
                      </Column>
                    </Row>
                    <Row>
                      <Column>
                        <span className="font-bold">Patient Advisors:</span> Our patient advisors can help you with questions you have about appropriate healthcare, medical bills, insurance denials, etc.
                      </Column>

                      <Column>
                        <span className="font-bold">Wellness:</span> Access wellness tools, health assessments, diet and workout plans. As well as hundreds of articles and resources to maintain your healthy lifestyle.
                      </Column>
                    </Row>
                    <Row className="py-2">
                      <Column>
                        <span className="text-red-600 font-bold">WEBSITE</span> www.cardplus.com
                      </Column>
                      <Column>
                        <span className="text-red-600 font-bold">TELEPHONE</span> 800.362.2667
                      </Column>
                    </Row>
                  </Grid>
                </div>
              </div>
                </Tab>
              </Tabs>
            }
        </ModalBody>
      </ComposedModal>

      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default MedicalPlanDetails;
